import React from "react";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
} from "@mui/material";
import ViewFile from "./ViewFile";
import HorizontalRuleIcon from "@mui/icons-material/HorizontalRule";

const ViewTable = ({ fieldName, fields, rows, data }) => {
  console.log(fieldName, fields, rows, data, "rows");
  return (
    <Box sx={{ marginBottom: 3 }}>
      <TableContainer
        component={Paper}
        sx={{
          boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
          borderRadius: "10px",
          width: "100%",
        }}
      >
        {" "}
        <Table
          sx={{
            border: "1px solid rgba(224, 224, 224, 1)",
            borderRadius: "10px",
            width: "100%",
          }}
        >
          <TableHead>
            <TableRow
              sx={{
                backgroundColor: "#488257",
                borderRadius: "10px",
                "& > th": {
                  color: "white",
                  fontWeight: "bold",
                  py: "0.5rem",
                  px: "0.5rem",
                  border: "1px solid rgba(224, 224, 224, 1)",
                },
              }}
            >
              {fields.map((field, idx) => (
                <TableCell key={idx} sx={{ minWidth: "30px" }}>
                  {field.title}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>

          <TableBody>
            {rows?.length > 0 &&
              rows?.map((row, index) => {
                return (
                  <TableRow
                    key={index}
                    sx={{
                      "& > td": {
                        border: "1px solid rgba(224, 224, 224, 1)",
                        py: "0rem",
                        px: "0.5rem",
                      },
                    }}
                  >
                    {fields?.map((field, idx) => {
                      return (
                        <TableCell
                          key={idx}
                          sx={{
                            minWidth: field.width,
                            maxWidth: field.width,
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            textAlign:
                              field?.fieldName === "serialNo" && "center",
                          }}
                        >
                          <Box
                            sx={{ minHeight: "30px", maxHeight: "30px", mt: 1 }}
                          >
                            {field.type === "file" ? (
                              <ViewFile filesList={row[field.fieldName]} />
                            ) : (
                              <Typography
                                variant="body2"
                                sx={{
                                  overflow: "hidden",
                                  whiteSpace: "nowrap",
                                  textOverflow: "ellipsis",
                                  fontSize: "14px",
                                  width: "6rem",
                                  textAlign: !row[field.fieldName] && "center",
                                }}
                              >
                                {row?.[field?.fieldName] || "-"}
                              </Typography>
                            )}
                          </Box>
                        </TableCell>
                      );
                    })}
                  </TableRow>
                );
              })}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default ViewTable;
